export default __webpack_public_path__ + "03_ReviewCommentary.4100442e.png";